/** Burger-Menü (Mobile Navigation) */
export function initBurgerMenu() {
  const burgerToggle = document.querySelector(".burger-menu-toggle");
  const navMenu = document.querySelector("#main-nav ul");
  const body = document.body;

  if (!burgerToggle || !navMenu) return;

  burgerToggle.addEventListener("click", (e) => {
    e.stopPropagation();
    const isExpanded = burgerToggle.getAttribute("aria-expanded") === "true";
    const newState = !isExpanded;

    burgerToggle.setAttribute("aria-expanded", newState);
    navMenu.classList.toggle("menu-open", newState);
    body.classList.toggle("menu-open", newState);
  });

  navMenu.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      burgerToggle.setAttribute("aria-expanded", "false");
      navMenu.classList.remove("menu-open");
      body.classList.remove("menu-open");
    });
  });

  navMenu.addEventListener("click", (e) => {
    if (e.target === navMenu) {
      burgerToggle.setAttribute("aria-expanded", "false");
      navMenu.classList.remove("menu-open");
      body.classList.remove("menu-open");
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && body.classList.contains("menu-open")) {
      burgerToggle.setAttribute("aria-expanded", "false");
      navMenu.classList.remove("menu-open");
      body.classList.remove("menu-open");
    }
  });
}
